import React, { useState, useRef } from "react";
import { Box, ThemeProvider, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { timelineData } from "./data/timelineData";
import { uiucTheme } from "./../../styles/theme";

import {
  HorizontalScrollContainer,
  TimelineSlice,
  StyledImage,
  dateBoxStyles,
  baseBlockStyles
} from "./../../styles/timelineStyles";

interface ThemeProps {
  setCurrentTheme: React.Dispatch<React.SetStateAction<typeof uiucTheme>>;
}

const MyTimeline: React.FC<ThemeProps> = ({ setCurrentTheme }) => {
  const theme = useTheme();
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ position: "relative", width: "100%", height: "100%", maxWidth: "100vw", overflow: "hidden" }}>
        <HorizontalScrollContainer ref={scrollContainerRef}>
          {timelineData.map((item) => {
            const isHovered = hoveredId === item.id;

            const ContentBlock = (
              <Box sx={{ ...baseBlockStyles, justifyContent: "flex-start" }}>
                <Box
                  sx={{
                    ...dateBoxStyles,
                  }}
                >
                  <Typography variant="h6" color="primary">
                    {item.date}
                  </Typography>
                </Box>
                <Typography variant="body2" color="primary" align="center">
                  {item.text}
                </Typography>
              </Box>
            );

            const ImageBlock = (
              <Box sx={{ ...baseBlockStyles, justifyContent: "flex-end", alignItems: "center" }}>
                <Link to={item.link}>
                  <StyledImage
                    src={item.image}
                    alt={item.alt}
                    opacity={isHovered ? 0.6 : 1}
                    onMouseEnter={() => {
                      setHoveredId(item.id);
                      setCurrentTheme(item.theme);
                    }}
                    onMouseLeave={() => setHoveredId(null)}
                  />
                </Link>
              </Box>
            );

            return (
              <TimelineSlice key={item.id}>
                {ContentBlock}
                {ImageBlock}
              </TimelineSlice>
            );
          })}
        </HorizontalScrollContainer>
      </Box>
    </ThemeProvider>
  );
};

MyTimeline.propTypes = {
  setCurrentTheme: PropTypes.func.isRequired,
};

export default MyTimeline;